import { useServicesContext } from "@/modules/core/services/services.context"
import { usersKeys } from "@/modules/users/gateway/usersKeys"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useAppStateActions } from "@/modules/auth/store/useAppStateStore"

export function useUser() {
  const { userProfileApi } = useServicesContext()
  const { setAppStateUser } = useAppStateActions()
  const { data } = useSuspenseQuery({
    queryKey: usersKeys.me(),
    queryFn: async () => {
      const result = await userProfileApi.getUser()
      const user = UserProfileEntity.fromDto(result)
      setAppStateUser({ user })
      return user
    },
  })
  return data
}
export const useIsAuthenticated = () => !!useUser()
